<div class="input-container">
  <label>
    {{label}}
    <div class="input-wrapper">
      <input
        [name]="inputName"
        [placeholder]="placeholder"
        [type]="type"
        (focus)="handleFocus()"
        (blur)="handleBlur()"
        [required]="required"
        [class.invalid]="control!.touched && control!.invalid"
        [formControl]="control!"
        [readOnly]="readonly"
      />
      <i *ngIf="rightIcon" class="fas {{rightIcon}} icon-right" (click)="handleRightIconClick()"></i>
    </div>
    <span *ngIf="control?.touched && !isFocused && control?.errors" class="validation-message">
      <ng-container *ngIf="control!.errors!['required']">{{'controls.errors.required' | translate}}</ng-container>
      <ng-container *ngIf="control!.errors!['email']">{{'controls.errors.invalid_email' | translate}}</ng-container>
      <ng-container *ngIf="control!.errors!['minlength']"> {{ 'controls.errors.min_length' | translate: { min: control!.errors!['minlength'].requiredLength } }}</ng-container>
      <ng-container *ngIf="!control!.errors!['minlength'] && control!.errors!['pattern'] && type === 'password'">{{'controls.errors.password_missing_special_char' | translate}}</ng-container>
    </span>
  </label>
</div>